import { MailSlurp } from 'mailslurp-client'

// King: Will rotate key and move this to .env today/tomorrow
const MailSlurpClient = new MailSlurp({
  apiKey: '0858ca74236d65f3bbaa1efeb2530682f84bccc2fa8a4658d7cb786956033a84',
})

export const getE2EEmailOTPByEmail = async ({ E2EEmail }: { E2EEmail: string }) => {
  const E2EEmailInboxId = `${E2EEmail.split('@').shift()}`
  const getEmail = await MailSlurpClient.waitController.waitForLatestEmail({
    inboxId: E2EEmailInboxId,
    timeout: 10000,
    unreadOnly: true,
  })

  if (getEmail.textExcerpt) {
    const match = getEmail.textExcerpt.match(/Your verification code is: \d{5}/)
    if (match) {
      const yourVerificationCodeOTPSentence = match[0]
      if (yourVerificationCodeOTPSentence) {
        const emailOTP = yourVerificationCodeOTPSentence.split(':').pop()?.trim()
        if (emailOTP) {
          await MailSlurpClient.emailController.deleteEmail({ emailId: getEmail.id })

          return emailOTP
        }
      }
    }
  }
}

export const emptyE2EEmailInboxByEmail = async ({ E2EEmail }: { E2EEmail: string }) => {
  const E2EEmailInboxId = `${E2EEmail.split('@').shift()}`
  await MailSlurpClient.emptyInbox(E2EEmailInboxId)
}

export const getBaseEmail = (email: string): string => {
  // Extract the base email part before any + or @
  // this allows us to use the same email for multiple tests
  const parts = email.split('+')
  const base = parts[0] ?? email
  const username = base.split('@')[0]
  if (!username) {
    throw new Error('Invalid email format')
  }
  return username
}

export const generateUniqueEmail = () => {
  const timestamp = Date.now()
  return `${AuthenticationE2E.Users.AccountSignup.EmailId}+${timestamp}@mailslurp.biz`
}

// unique phone number for testing, but having same area code of 5555 for cleanup
export const generateUniquePhone = () => {
  let digits = ''
  for (let i = 0; i < 6; i++) {
    // Generate a single random digit (0-9)
    digits += Math.floor(Math.random() * 10).toString()
  }
  return `5555${digits}`
}

const prefix = <const T extends string>(id: T) => `Authentication.${id}` as const

export type AccountSignupE2EUser = {
  Email: string
  EmailId: string
  FirstName: string
  LastName: string
}

export const AuthenticationE2E = {
  Users: {
    General: '9e28fcd0-d041-4b82-8aae-1e46aa17dd76@mailslurp.biz',
    Statsig: 'cf26aa5b-fabb-4ef5-8c2b-3279f424353a@mailslurp.biz',
    NotInStatsig: '2cb2a6f7-f965-42c1-9ade-de834eb4f8e5@mailslurp.biz',
    AccountSignup: {
      Email: '90d06fde-2677-4c5a-b4c0-57a382cab41e@mailslurp.biz',
      EmailId: '90d06fde-2677-4c5a-b4c0-57a382cab41e',
      FirstName: 'End To End Testing',
      LastName: 'Account Creation',
    } satisfies AccountSignupE2EUser,
  },
  Ids: {
    Press: {
      SignOut: prefix('Press.SignOut'),
      GetStarted: prefix('Press.GetStarted'),
      EmailSubmit: prefix('Press.EmailSubmit'),
      EmailOTPSubmit: prefix('Press.EmailOTPSubmit'),
      ConfirmSignOut: 'Yes',
      SubmitSignup: prefix('Press.SubmitSignup'),
    },
    View: {
      VerifyOTP: prefix('View.VerifyOTP'),
      VerifyEmailOTP: prefix('View.VerifyEmailOTP'),
    },
    Text: {
      FeatureGateForEndToEndUsers: prefix('Text.FeatureGateForEndToEndUsers'),
    },
    Input: {
      Email: prefix('Input.Email'),
      OTP: 'otp-input-hidden',
      FirstName: prefix('Input.FirstName'),
      LastName: prefix('Input.LastName'),
      Phone: prefix('Input.Phone'),
      EmailOTP: prefix('Input.EmailOTP'),
    },
  },
} as const
